export default {
    pluginName: 'investment',
    backendDataType: 'VC',
    rowIdKey: 'DOC_ID',
    edit: 'data_edit',
    count: 'vc_count',
    totalCount: 'total_vc_count',
    fieldI18nKey: 'commonInvestment',
    maxPerFolder: 'max_vc_per_folder',
    maxOp: 'max_op_vc',
    staticFields: ['TITLE'],
    dataId: 'ID',
};
